import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class SJIService {
  userName = '';
  currentCompanyId: number = 0;

  constructor(private http: HttpClient) {

  }

  /**Verify that it is empty */
  isEmpty(obj) {
    if (typeof obj == "undefined" || obj == null || obj == '' || obj == {}) {
      return true;
    } else {
      if (typeof obj == "string") {
        if (obj.replace(/\s+/g, "") == '') return true;
      }
      return false;
    }
  }

  /* clone a instance for a object */
  cloneObject<T>(obj: T): T {
    const copy: T = JSON.parse(JSON.stringify(obj)) as T;
    return copy;
  }

  /**
   *  Format the input datetime to be UTC time zone datetime format.
   *  Note: Here, It will not modify the datetime value. It only simply keep the same datetime value, but format it as timezone "0".
   *  The scenario is: what client input in the Form, system always assume it is datetime value for UTC datetime.
   *  And client's input datetime will be directly saved into database without convert it to UTC datetime value.
   *  And we always assume the datetime value saved in database is UTC datetime.
   */
  public theCorrectTimeZone(d: Date): Date {
    if ( d ) {
      const year = d.getFullYear();
      const month = d.getMonth();
      const date = d.getDate();
      const hour = d.getHours();
      const minute = d.getMinutes();
      const second = d.getSeconds();
      const str = year + '-' + this.padding_left(String(month + 1), '0', 2) + '-' + this.padding_left(String(date), '0', 2)
        + 'T' + this.padding_left(String(hour), '0', 2) + ':' + this.padding_left(String(minute), '0', 2)
        + ':' + this.padding_left(String(second), '0', 2)
        + '.000Z';

      return JSON.parse('"' + str + '"');
    } else {
      return null;
    }
  }

  private padding_left(s, c, n) {
    if (! s || ! c || s.length >= n) {
      return s;
    }
    var max = (n - s.length)/c.length;
    for (var i = 0; i < max; i++) {
      s = c + s;
    }
    return s;
  }

  get(url: string, params?: any) {
    return this.http.get(url,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: params
      }
    );
  }
  post(url, data) {
    return this.http.post(url, data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }
  upload(url, data) {
    return this.http.post(url, data);
  }
  postDownload(url, param) {
    return this.http
      .post(url, param, { responseType: 'blob' });
  }
}
